/**
 * @license
 * Copyright 2012 Dan Vanderkam (danvdk@gmail.com)
 * MIT-licensed (http://opensource.org/licenses/MIT)
 */
/*global Dygraph:false */
var Misc = require('utils/misc');
var i18n = require('utils/i18n');

Dygraph.Plugins.TrovisLegend = (function () {
    /*
Current bits of jankiness:
- Uses two private APIs:
    1. Dygraph.optionsViewForAxis_
    2. dygraph.plotter_.area
- Registers for a "predraw" event, which should be renamed.
- I call calculateEmWidthInDiv more often than needed.
*/

    /*global Dygraph:false */
    'use strict';

    /**
     * Creates the legend, which appears when the user hovers over the chart.
     * The legend can be either a user-specified or generated div.
     *
     * @constructor
     */
    // MOD BEGIN
    var getLabelParts = function (serie) {
        return [serie, ''];
    };

    function getShiftedTime(serieInfo, pt, g) {
        if (!serieInfo.displaySettings || !serieInfo.displaySettings.timeshift) {
            return '';
        }

        var sourceData = g && g.user_attrs_ && g.user_attrs_.sourceData;
        var diff = sourceData && sourceData.timeshift && sourceData.timeshift[serieInfo.index];
        return ' [' + moment(pt.xval - diff * 1000).format('DD.MM.YYYY HH:mm') + ']';
    }

    var legend = function () {
        this.legend_div_ = null;
        this.is_generated_div_ = false; // do we own this div, or was it user-specified?
        this.buttonBlockMargin = 15;
        this.legendPadding = 12;

        this.ui = {
            legendExtern: '.dygraph-legend-extern',
            legend: '.dygraph-legend',
            legendLine: '.js-chart-legend-line',
            legendDate: '.js-chart-legend-date',
        };
    };

    legend.prototype.fixLegendExtern = function (g) {
        var self = this;

        var legend_id = g.maindiv_.getAttribute('data-legend');
        legend_id = legend_id != null ? '#chart-legend-' + legend_id : '';

        var legendExtern = this.ui.legendExtern + legend_id;
        var legendIntern = '#' + g.maindiv_.id + ' ' + this.ui.legend;

        if (!this.legendContextObj) {
            if (!window.trovisChartLegend) {
                window.trovisChartLegend = {};
            }
            this.legendContextObj = window.trovisChartLegend;
        }

        $(legendIntern).show();
        var legendArray = [];

        var lineLegendCount = 0;
        var dateLegendCount = 0;

        _.each($(legendIntern), function (x) {
            var newLineCount = $(x).find(self.ui.legendLine).length;
            dateLegendCount = Math.min(Math.max($(x).find(self.ui.legendLine).length, dateLegendCount), 1);
            lineLegendCount += newLineCount;
            var txtArray = $(x).html().split('<br>');
            txtArray = _.without(txtArray, '');
            legendArray = _.union(legendArray, txtArray);
        });

        var $legendExtern = $(legendExtern);
        if ($legendExtern.length == 0) return;
        var legendExternDiv = $legendExtern[0];
        if (legendExternDiv.legends === undefined) legendExternDiv.legends = {};
        legendExternDiv.legends[g.maindiv_.id] = legendArray;

        // check if there are legend data connected with an invisible div
        _.each(_.keys(legendExternDiv.legends), function (key) {
            var l = $('#' + key);
            if (l.length == 0) {
                delete legendExternDiv.legends[key];
            }
        });

        //now the legend array is going to be rebuild. Include only one date, then all lines
        var isFirst = true;
        legendArray = [];
        dateLegendCount = 0;
        lineLegendCount = 0;

        _.each(legendExternDiv.legends, function (value) {
            if (value.length <= 0) return;

            // Time - display only once
            if (isFirst) {
                legendArray.push(value[0]);
                isFirst = false;
                dateLegendCount = 1;
            }

            for (var i = 1; i < value.length; i++) {
                legendArray.push(value[i]);
                lineLegendCount = lineLegendCount + 1;
            }
        });

        var itemCount = dateLegendCount + lineLegendCount;
        var legendTxt = legendArray.join(' ');
        $(legendExtern).html(legendTxt);

        // unify the legend width
        var maxWidth = 0;
        _.each([legendExtern, legendIntern], function (l) {
            if (maxWidth == 0) {
                _.each($(l).find('span'), function (x) {
                    var w = $(x).width();
                    maxWidth = Math.max(w, maxWidth);
                });
            }
        });

        var legendWidth = $(legendExtern).width() - this.legendPadding;
        if (this.legendContextObj.lastLegendWidth !== legendWidth || this.legendContextObj.lastItemCount < itemCount) {
            this.legendContextObj.lastLegendWidth = legendWidth;
            this.legendContextObj.lastMaxWidth = 0;
            this.legendContextObj.lastItemCount = itemCount;
        }

        itemCount = Math.max(itemCount, this.legendContextObj.lastItemCount);
        maxWidth = Math.max(maxWidth, this.legendContextObj.lastMaxWidth);
        this.legendContextObj.lastMaxWidth = maxWidth;

        var colCount = Math.min(itemCount, Math.floor(legendWidth / maxWidth));
        maxWidth = Math.max(maxWidth, Math.floor(legendWidth / colCount));

        $(legendExtern + ' > span').css('width', '' + maxWidth + 'px');
        $(legendExtern).show();
        $(legendIntern).hide();
    };

    legend.prototype.toString = function () {
        return 'Trovis Legend Plugin';
    };
    // MOD END
    // (defined below)
    var generateLegendDashHTML;

    /**
     * This is called during the dygraph constructor, after options have been set
     * but before the data is available.
     *
     * Proper tasks to do here include:
     * - Reading your own options
     * - DOM manipulation
     * - Registering event listeners
     *
     * @param {Dygraph} g Graph instance.
     * @return {object.<string, function(ev)>} Mapping of event names to callbacks.
     */
    legend.prototype.activate = function (g) {
        var div;
        var divWidth = g.getOption('labelsDivWidth');

        var userLabelsDiv = g.getOption('labelsDiv');
        if (userLabelsDiv && null !== userLabelsDiv) {
            if (typeof userLabelsDiv == 'string' || userLabelsDiv instanceof String) {
                div = document.getElementById(userLabelsDiv);
            } else {
                div = userLabelsDiv;
            }
        } else {
            // Default legend styles. These can be overridden in CSS by adding
            // "!important" after your rule, e.g. "left: 30px !important;"
            var messagestyle = {
                position: 'absolute',
                fontSize: '14px',
                zIndex: 10,
                width: divWidth + 'px',
                top: '0px',
                left: g.size().width - divWidth - 2 + 'px',
                background: 'white',
                lineHeight: 'normal',
                textAlign: 'left',
                overflow: 'hidden',
            };

            // TODO(danvk): get rid of labelsDivStyles? CSS is better.
            Dygraph.update(messagestyle, g.getOption('labelsDivStyles'));
            div = document.createElement('div');
            div.className = 'dygraph-legend';
            for (var name in messagestyle) {
                if (!messagestyle.hasOwnProperty(name)) continue;

                try {
                    div.style[name] = messagestyle[name];
                } catch (e) {
                    console.warn('You are using unsupported css properties for your ' + 'browser in labelsDivStyles');
                }
            }

            // TODO(danvk): come up with a cleaner way to expose this.
            g.graphDiv.appendChild(div);
            this.is_generated_div_ = true;
        }

        this.legend_div_ = div;
        this.one_em_width_ = 10; // just a guess, will be updated.

        return {
            select: this.select,
            deselect: this.deselect,
            // TODO(danvk): rethink the name "predraw" before we commit to it in any API.
            predraw: this.predraw,
            didDrawChart: this.didDrawChart,
        };
    };

    // Needed for dashed lines.
    var calculateEmWidthInDiv = function (div) {
        var sizeSpan = document.createElement('span');
        sizeSpan.setAttribute('style', 'margin: 0; padding: 0 0 0 1em; border: 0;');
        div.appendChild(sizeSpan);
        var oneEmWidth = sizeSpan.offsetWidth;
        div.removeChild(sizeSpan);
        return oneEmWidth;
    };

    var escapeHTML = function (str) {
        return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    };

    legend.prototype.select = function (e) {
        if (this.lastSelectData && e.selectedRow == -1) {
            e.selectedX = this.lastSelectData.xValue;
            e.selectedPoints = this.lastSelectData.points;
            e.selectedRow = this.lastSelectData.row;
        }

        this.lastSelectData = {
            xValue: e.selectedX,
            points: e.selectedPoints,
            row: e.selectedRow,
        };

        var xValue = e.selectedX;
        var points = e.selectedPoints;
        var row = e.selectedRow;

        var legendMode = e.dygraph.getOption('legend');
        if (legendMode === 'never') {
            this.legend_div_.style.display = 'none';
            return;
        }

        if (legendMode === 'follow') {
            // create floating legend div
            var area = e.dygraph.plotter_.area;
            var labelsDivWidth = e.dygraph.getOption('labelsDivWidth');
            var yAxisLabelWidth = e.dygraph.getOptionForAxis('axisLabelWidth', 'y');
            // determine floating [left, top] coordinates of the legend div
            // within the plotter_ area
            // offset 20 px to the right and down from the first selection point
            // 20 px is guess based on mouse cursor size
            var leftLegend = points[0].x * area.w + 20;
            var topLegend = points[0].y * area.h - 20;

            // if legend floats to end of the window area, it flips to the other
            // side of the selection point
            if (leftLegend + labelsDivWidth + 1 > window.scrollX + window.innerWidth) {
                leftLegend = leftLegend - 2 * 20 - labelsDivWidth - (yAxisLabelWidth - area.x);
            }

            e.dygraph.graphDiv.appendChild(this.legend_div_);
            this.legend_div_.style.left = yAxisLabelWidth + leftLegend + 'px';
            this.legend_div_.style.top = topLegend + 'px';
        }

        // MOD BEGIN
        var html = legend.generateLegendHTML(e.dygraph, xValue, points, this.one_em_width_, row);
        this.legend_div_.innerHTML = html;

        this.legend_div_.style.display = '';
        this.fixLegendExtern(e.dygraph);
        // MOD END
    };

    legend.prototype.deselect = function (e) {
        var legendMode = e.dygraph.getOption('legend');
        if (legendMode !== 'always') {
            this.legend_div_.style.display = 'none';
        }

        // Have to do this every time, since styles might have changed.
        var oneEmWidth = calculateEmWidthInDiv(this.legend_div_);
        this.one_em_width_ = oneEmWidth;

        var html = legend.generateLegendHTML(e.dygraph, undefined, undefined, oneEmWidth, null);
        this.legend_div_.innerHTML = html;
    };

    legend.prototype.didDrawChart = function (e) {
        this.deselect(e);
    };

    // Right edge should be flush with the right edge of the charting area (which
    // may not be the same as the right edge of the div, if we have two y-axes.
    // TODO(danvk): is any of this really necessary? Could just set "right" in "activate".
    /**
     * Position the labels div so that:
     * - its right edge is flush with the right edge of the charting area
     * - its top edge is flush with the top edge of the charting area
     * @private
     */
    legend.prototype.predraw = function (e) {
        // Don't touch a user-specified labelsDiv.
        if (!this.is_generated_div_) return;

        // TODO(danvk): only use real APIs for this.
        e.dygraph.graphDiv.appendChild(this.legend_div_);
        var area = e.dygraph.plotter_.area;
        var labelsDivWidth = e.dygraph.getOption('labelsDivWidth');
        this.legend_div_.style.left = area.x + area.w - labelsDivWidth - 1 + 'px';
        this.legend_div_.style.top = area.y + 'px';
        this.legend_div_.style.width = labelsDivWidth + 'px';
    };

    /**
     * Called when dygraph.destroy() is called.
     * You should null out any references and detach any DOM elements.
     */
    legend.prototype.destroy = function () {
        this.legend_div_ = null;
    };

    /**
     * @private
     * Generates HTML for the legend which is displayed when hovering over the
     * chart. If no selected points are specified, a default legend is returned
     * (this may just be the empty string).
     * @param {number} x The x-value of the selected points.
     * @param {Object} sel_points List of selected points for the given
     *   x-value. Should have properties like 'name', 'yval' and 'canvasy'.
     * @param {number} oneEmWidth The pixel width for 1em in the legend. Only
     *   relevant when displaying a legend with no selection (i.e. {legend:
     *   'always'}) and with dashed lines.
     * @param {number} row The selected row index.
     */
    legend.generateLegendHTML = function (g, x, sel_points, oneEmWidth, row) {
        var getNoValue = function (pt, serieInfo, seriesIdx) {
            if (serieInfo.displaySettings && serieInfo.displaySettings.chartType == 2) {
                var ptObj = g.user_attrs_.lineAggPoints[seriesIdx - 1] || {};
                var selectedPt = undefined;
                Object.keys(ptObj).forEach(function (key) {
                    var fk = parseFloat(key);
                    if (pt.canvasx >= fk && pt.canvasx <= fk + ptObj[key].xLength) {
                        selectedPt = ptObj[key];
                    }
                });

                if (!selectedPt) {
                    return '&horbar;';
                }

                var yval = selectedPt.p.yval;
                if (serieInfo.axisCalc.k) {
                    yval = (yval - serieInfo.axisCalc.q) / serieInfo.axisCalc.k;
                }

                return getValueWithUnits(yval, undefined, serieInfo);
            }

            if (serieInfo.displaySettings && serieInfo.displaySettings.chartType == 1) {
                var chartWidth = g.user_attrs_.barWidth;

                var xrange = [pt.canvasx - chartWidth, pt.canvasx + chartWidth];
                var timeRange = _.map(xrange, function (a) {
                    return g.toDataXCoord(a);
                });

                var pointsInside = Misc.selectWhere(
                    g.user_attrs_.originalData,
                    function (row) {
                        var t = new Date(row[0]).getTime();
                        return t >= timeRange[0] && t <= timeRange[1] && row[seriesIdx] !== null;
                    },
                    function (row) {
                        return row[seriesIdx];
                    }
                );

                if (pointsInside.length == 1) {
                    return getValueWithUnits(pointsInside[0], undefined, serieInfo);
                }
            }
            return '&horbar;';
        };

        var getValueWithUnits = function (value, serie, seriesInfo) {
            seriesInfo = seriesInfo ||
                g.getSeriesInfo(serie) || {
                    type: '',
                    format: '',
                    unit: '',
                };
            var result = Misc.getValueDisplayInfos(
                parseFloat(value),
                seriesInfo.type,
                seriesInfo.format,
                seriesInfo.unit,
                seriesInfo.display_unit,
                seriesInfo.is_unit_fixed
            );
            return result.value + ' ' + result.unit;
        };

        // TODO(danvk): deprecate this option in place of {legend: 'never'}
        if (g.getOption('showLabelsOnHighlight') !== true) return '';

        // If no points are selected, we display a default legend. Traditionally,
        // this has been blank. But a better default would be a conventional legend,
        // which provides essential information for a non-interactive chart.
        var html, sepLines, i, dash, strokePattern;
        var labels = g.getLabels();

        if (typeof x === 'undefined') {
            if (g.getOption('legend') != 'always') {
                return '';
            }

            sepLines = g.getOption('labelsSeparateLines');
            html = '';
            for (i = 1; i < labels.length; i++) {
                var series = g.getPropertiesForSeries(labels[i]);
                var labelParts = getLabelParts(labels[i]);
                if (!series.visible) continue;

                if (html !== '') html += sepLines ? '<br/>' : ' ';
                strokePattern = g.getOption('strokePattern', labels[i]);
                dash = generateLegendDashHTML(strokePattern, series.color, oneEmWidth);

                // MOD BEGIN
                var serieInfo = g.getSeriesInfo(labels[i]);

                html +=
                    '<span  class="js-chart-legend-line" style=\'font-weight: bold; color: ' +
                    series.color +
                    ";'>" +
                    escapeHTML(i18n.DATAPOINT_BY_ID(serieInfo.device, labelParts[0])) +
                    ': <span class="dygraph-legend-value">' +
                    dash +
                    '</span></span><br>';
                // MOD END
            }
            return html;
        }

        // TODO(danvk): remove this use of a private API
        var xOptView = g.optionsViewForAxis_('x');
        var xvf = xOptView('valueFormatter');
        // MOD BEGIN
        html = '<span class="js-chart-legend-date">' + xvf.call(g, x, xOptView, labels[0], g, row, 0);
        // MOD END
        if (html !== '') {
            html += ':';
        }
        html += '</span><br>';

        var yOptViews = [];
        var num_axes = g.numAxes();
        for (i = 0; i < num_axes; i++) {
            // TODO(danvk): remove this use of a private API
            yOptViews[i] = g.optionsViewForAxis_('y' + (i ? 1 + i : ''));
        }
        var showZeros = g.getOption('labelsShowZeroValues');
        sepLines = g.getOption('labelsSeparateLines');
        var highlightSeries = g.getHighlightSeries();
        for (i = 0; i < sel_points.length; i++) {
            var pt = sel_points[i];

            // MOD BEGIN
            var seriesIdx = labels.indexOf(pt.name);

            var cls = ' class="js-chart-legend-line' + (pt.name == highlightSeries ? ' highlight' : '') + '"';
            var series = g.getPropertiesForSeries(pt.name);
            var strokePattern = g.getOption('strokePattern', labels[seriesIdx]);
            var labelParts = getLabelParts(labels[seriesIdx]);
            var interpolated = undefined;
            if (g.isInterpolatedValue) {
                interpolated = g.isInterpolatedValue(row, seriesIdx - 1);
            }

            // MOD END
            if (pt.yval === 0 && !showZeros) continue;
            var isOK = Dygraph.isOK(pt.canvasy);
            if (sepLines) html += '<br/>';

            var yOptView = yOptViews[series.axis - 1];
            var fmtFunc = yOptView('valueFormatter');
            var yval = fmtFunc.call(g, pt.yval, yOptView, pt.name, g, row, labels.indexOf(pt.name));

            if (g.user_attrs_.originalData) {
                var od = g.user_attrs_.originalData;
                var row = od[pt.idx];
                if (row) {
                    yval = row[seriesIdx];
                }
            }

            // TODO(danvk): use a template string here and make it an attribute.
            // MOD BEGIN
            var serieInfo = g.getSeriesInfo(labels[seriesIdx]);

            html +=
                '<span' +
                cls +
                '>' +
                " <span style='" +
                (serieInfo && serieInfo.selected ? 'font-weight:bold; ' : '') +
                ' color: ' +
                series.color +
                ";'>" +
                escapeHTML(i18n.DATAPOINT_BY_ID(serieInfo.device, labelParts[0])) +
                getShiftedTime(serieInfo, pt, g) +
                ':<span class="dygraph-legend-value">&#160;' +
                (isOK ? getValueWithUnits(yval, labels[seriesIdx]) : getNoValue(pt, serieInfo, seriesIdx)) +
                ' </span></span></span><br>';
            // MOD END
        }
        return html;
    };

    /**
     * Generates html for the "dash" displayed on the legend when using "legend: always".
     * In particular, this works for dashed lines with any stroke pattern. It will
     * try to scale the pattern to fit in 1em width. Or if small enough repeat the
     * pattern for 1em width.
     *
     * @param strokePattern The pattern
     * @param color The color of the series.
     * @param oneEmWidth The width in pixels of 1em in the legend.
     * @private
     */
    generateLegendDashHTML = function (strokePattern, color, oneEmWidth) {
        // IE 7,8 fail at these divs, so they get boring legend, have not tested 9.
        var isIE = /MSIE/.test(navigator.userAgent) && !window.opera;
        if (isIE) return '&mdash;';

        // Easy, common case: a solid line
        if (!strokePattern || strokePattern.length <= 1) {
            return (
                '<div style="display: inline-block; position: relative; ' +
                'bottom: .5ex; padding-left: 1em; height: 1px; ' +
                'border-bottom: 2px solid ' +
                color +
                ';"></div>'
            );
        }

        var i, j, paddingLeft, marginRight;
        var strokePixelLength = 0,
            segmentLoop = 0;
        var normalizedPattern = [];
        var loop;

        // Compute the length of the pixels including the first segment twice,
        // since we repeat it.
        for (i = 0; i <= strokePattern.length; i++) {
            strokePixelLength += strokePattern[i % strokePattern.length];
        }

        // See if we can loop the pattern by itself at least twice.
        loop = Math.floor(oneEmWidth / (strokePixelLength - strokePattern[0]));
        if (loop > 1) {
            // This pattern fits at least two times, no scaling just convert to em;
            for (i = 0; i < strokePattern.length; i++) {
                normalizedPattern[i] = strokePattern[i] / oneEmWidth;
            }
            // Since we are repeating the pattern, we don't worry about repeating the
            // first segment in one draw.
            segmentLoop = normalizedPattern.length;
        } else {
            // If the pattern doesn't fit in the legend we scale it to fit.
            loop = 1;
            for (i = 0; i < strokePattern.length; i++) {
                normalizedPattern[i] = strokePattern[i] / strokePixelLength;
            }
            // For the scaled patterns we do redraw the first segment.
            segmentLoop = normalizedPattern.length + 1;
        }

        // Now make the pattern.
        var dash = '';
        for (j = 0; j < loop; j++) {
            for (i = 0; i < segmentLoop; i += 2) {
                // The padding is the drawn segment.
                paddingLeft = normalizedPattern[i % normalizedPattern.length];
                if (i < strokePattern.length) {
                    // The margin is the space segment.
                    marginRight = normalizedPattern[(i + 1) % normalizedPattern.length];
                } else {
                    // The repeated first segment has no right margin.
                    marginRight = 0;
                }
                // MOD BEGIN
                dash +=
                    '<div style="cursor:pointer; display: inline-block; position: relative; ' +
                    'bottom: .5ex; margin-right: ' +
                    marginRight +
                    'em; padding-left: ' +
                    paddingLeft +
                    'em; height: 1px; border-bottom: 2px solid ' +
                    color +
                    ';"></div>';
                // MOD END
            }
        }
        return dash;
    };

    return legend;
})();

// MOD BEGIN
// old legend has to be deactivated
Dygraph.PLUGINS.push(Dygraph.Plugins.TrovisLegend);

for (var i = 0; i < Dygraph.PLUGINS.length; i++) {
    var tmp = Dygraph.PLUGINS[i];
    if (tmp.generateLegendHTML) {
        Dygraph.PLUGINS.splice(i, 1);
        break;
    }
}
// MOD END
